import { Group, GroupProps, composeRenderProps } from 'react-aria-components';
import { tv, VariantProps } from 'tailwind-variants';

import { cn } from '../../lib/styles';
import { fieldStyles } from './Field.utils';

export function FieldError(props: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      {...props}
      className={cn(props.className, 'min-h-5 h-5 max-h-5 pt-1 text-text-destructive font-body-sm truncate text-left')}
    />
  );
}

export const fieldGroupStyles = tv({
  extend: fieldStyles,
  base: 'group flex items-center',
});

export function FieldGroup({ size, variant, ...rest }: GroupProps & VariantProps<typeof fieldGroupStyles>) {
  return (
    <Group
      {...rest}
      className={composeRenderProps(rest.className, (className, renderProps) =>
        fieldGroupStyles({ ...renderProps, size, variant, className }),
      )}
    />
  );
}
